export default __webpack_public_path__ + "static/media/hosting.169b64fb.png";